module.exports = __webpack_public_path__ + "static/media/coin_2.2066f344.webp";